import { Tabs } from "radix-ui";

const TabContent = ({ value, children }) => (
  <Tabs.Content value={value} className="mt-4">
    {children}
  </Tabs.Content>
);

export default TabContent;
